import * as actionTypes from './actionTypes'
import DisplayMessage from './data/DisplayMessage'
import { Transaction } from './data/Transaction'
import StatusResult from './data/StatusResult'
import TerminalInfo from './data/TerminalInfo'

export const connect = () => ({
    type: actionTypes.PAYMENT_TERMINAL_CONNECT,
})

export const disconnect = () => ({
    type: actionTypes.PAYMENT_TERMINAL_DISCONNECT,
})

export const sendRequest = (request, terminalId = null, terminalType = null) => ({
    type: actionTypes.PAYMENT_TERMINAL_SEND_REQUEST,
    request,
    terminalId,
    terminalType,
})


export const configure = (config: any) => ({
    type: actionTypes.PAYMENT_TERMINAL_CONFIGURE,
    config,
})

export const connected = () => ({
    type: actionTypes.PAYMENT_TERMINAL_CONNECTED,
})

export const disconnected = () => ({
    type: actionTypes.PAYMENT_TERMINAL_DISCONNECTED,
})

export const displayMessageReceived = (message: DisplayMessage) => ({
    type: actionTypes.PAYMENT_TERMINAL_DISPLAY_MESSAGE_RECEIVED,
    message,
})

export const error = (message, data) => ({
    type: actionTypes.PAYMENT_TERMINAL_ERROR,
    message,
    data,
})

export const idle = () => ({
    type: actionTypes.PAYMENT_TERMINAL_IDLE,
})

export const transactionCompleted = (result: Transaction, request) => ({
    type: actionTypes.PAYMENT_TERMINAL_TRANSACTION_COMPLETED,
    request,
    result,
})

export const transactionProcessing = (transaction: Transaction, request = undefined) => ({
    type: actionTypes.PAYMENT_TERMINAL_TRANSACTION_PROCESSING,
    request,
    transaction,
})

export const statusChanged = (status: StatusResult, request = null) => ({
    type: actionTypes.PAYMENT_TERMINAL_STATUS_CHANGED,
    request,
    status,
})

export const terminalInfoReceived = (terminalInfo: TerminalInfo, request = null) => ({
    type: actionTypes.PAYMENT_TERMINAL_INFO_RECEIVED,
    request,
    terminalInfo,
})

export const receiveRawResponse = (response, request) => ({
    type: actionTypes.PAYMENT_TERMINAL_RECEIVE_RAW_RESPONSE,
    request,
    response,
})

export const receiveRawRequest = (request) => ({
    type: actionTypes.PAYMENT_TERMINAL_RECEIVE_RAW_REQUEST,
    request,
})
